module.exports = __webpack_public_path__ + "static/img/皮带锚杆识别.0581f197.png";